// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 396) return "static/chunks/396.86bb127b57f8d5a6.js";
	if (chunkId === 61) return "static/chunks/61.2063a81c507036de.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"345":"a9bd2717816d08ed","851":"944f794205bc9677","916":"a46f68bc4f065fbb"}[chunkId] + ".js";
};